import { createSlice } from "@reduxjs/toolkit";
import { CoreUiStoreSlices } from "../../../configs/_coreui.store.slice";

export interface CoreUiLayoutStoreSlice {
  sidebarShow: boolean;
  sidebarUnfoldable: boolean;
  asideShow: boolean;
  theme: string;
}

const initialState: CoreUiLayoutStoreSlice = {
  sidebarShow: true,
  sidebarUnfoldable: false,
  asideShow: false,
  theme: "light",
};

const coreuiLayoutSlice = createSlice({
  name: "coreuiLayout",
  initialState,
  reducers: {
    storeCoreUiSetLayout: (state, { payload }) => {
      return { ...state, ...payload };
    },
  },
});

// Actions
export const { storeCoreUiSetLayout: storeCoreUiSetLayout } =
  coreuiLayoutSlice.actions;

// Selectors
export const storeCoreUiSelectLayout = (state: CoreUiStoreSlices) =>
  state.coreuiLayout;

export const storeCoreUiSelectSidebarShow = (state: CoreUiStoreSlices) =>
  state.coreuiLayout.sidebarShow;

export const storeCoreUiSelectSidebarUnfoldable = (state: CoreUiStoreSlices) =>
  state.coreuiLayout.sidebarUnfoldable;

export const storeCoreUiSelectAsideShow = (state: CoreUiStoreSlices) =>
  state.coreuiLayout.asideShow;

export const storeCoreUiSelectTheme = (state: CoreUiStoreSlices) =>
  state.coreuiLayout.theme;

// Reducer
export default coreuiLayoutSlice.reducer;
